export default __webpack_public_path__ + "static/media/botIcon.2a128453.svg";